"use strict";

exports.__esModule = true;
exports.CreateScheduleScreen = CreateScheduleScreen;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _CreateScheduleWizard = require("../Schedule/CreateScheduleWizard");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function CreateScheduleScreen(_ref) {
  var location = _ref.location;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var query = new URLSearchParams(location.search);
  var basedOn = query.get("basedOn");
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("CreateScheduleScreen.title", "New Schedule"),
    "data-testid": "CreateScheduleScreen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("CreateScheduleScreen.navbar.title", "New Schedule")
  }), /*#__PURE__*/_react["default"].createElement(_CreateScheduleWizard.CreateScheduleWizard, {
    basedOn: basedOn
  }));
}